<div class="dam-element">
  <h6>Версия &laquo;{{ damItem?.header }}&raquo;</h6>

  <nb-actions>
    <nb-action>ID {{ damItem?.documentId }}</nb-action>
    <nb-action>
      <span i18n="@@Updated">Изменено</span>&nbsp;{{ (damItem?.updatedAt || damItem?.createdAt) | date: 'dd.MM.yyyy hh:mm' }}
    </nb-action>
    <nb-action>
      <button type="button" nbButton size="small" (click)="showUploader = !showUploader">Загрузить новый файл</button>
    </nb-action>
  </nb-actions>

  <app-uploader (upload)="onUpload($event)" [hidden]="!showUploader"/>

  <div class="section" *ngIf="damItem">
    <a (click)="show(actions, damItem.id)" target="_blank">
      <app-secured-image *ngIf="damService.showThumbnail(damItem?.mimeType)" src="/dam/get-image-dynamic-version/{{damItem.id}}/800/true"/>
      <img *ngIf="!damService.showThumbnail(damItem?.mimeType)" style="height: 100px;" class="vivid" src="/assets/images/vivid/{{damService.getExtension(damItem)}}.svg" alt="">
    </a>

    <!--      <span class="clr-black-sec fw-500 fs-12">-->
    <!--        <span i18n="@@Approved">Подтверждено</span>: {{damItem?.documentId}}-->
    <!--			</span>-->
  </div>
</div>

<ng-template #actions let-content="content">
  <a download size="small" nbButton [href]="content" i18n="@@Download"> Скачать </a>
</ng-template>

